import { render, staticRenderFns } from "./VoucherForm.vue?vue&type=template&id=6b523f54&scoped=true"
import script from "./VoucherForm.vue?vue&type=script&lang=js"
export * from "./VoucherForm.vue?vue&type=script&lang=js"
import style0 from "./VoucherForm.vue?vue&type=style&index=0&id=6b523f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b523f54",
  null
  
)

export default component.exports